import React, { useState } from "react";

const ReturnButton = ({ customStyle = "", onClick, isDisabled = false, ...props }: any) => {
  return (
    <div
      onClick={onClick}
      className={`flex items-center ${isDisabled ? "" : "hover:cursor-pointer"} group`}
    >
      <button className={`text-[#808080] ${isDisabled ? "" : "group-hover:text-[#FF861A]"}`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M15.4099 16.59L10.8299 12L15.4099 7.41L13.9999 6L7.99991 12L13.9999 18L15.4099 16.59Z"
            fill="currentColor"
          />
        </svg>
      </button>
      <p className={`py-1 px-2 text-sm alu-text-base-1 ${isDisabled ? "" : "group-hover:text-[#FF861A]"}`}>
        戻る
      </p>
    </div>
  );
};

export default ReturnButton;
